import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';

import LandingPage from "./components/LandingPage";

import HomePage from "./components/HomePage";
import CoursePage from "./components/CoursePage";
import CompaniesPage from "./components/CompaniesPage";
import DigitalPage from "./components/DigitalPage";
import StayRelevantPage from "./components/StayRelevantPage";
import AboutUsPage from "./components/AboutUsPage";
import Footer from "./components/Footer";
import DigitalMarketingIntensive from "./components/CoursePage/Courses/DigMk-Inten";
import WebDevelopmentImmersive from "./components/CoursePage/Courses/WebDev-Immer";
import WebDevelopmentIntensive from "./components/CoursePage/Courses/WebDev-Inten";
import DataScienceIntensive from "./components/CoursePage/Courses/DataSci-Inten";
import DataScienceImmersive from "./components/CoursePage/Courses/DataSci-Immer";
import ExperienceDesign from "./components/CoursePage/Courses/Ex-Design";
import ApplyNow from "./components/ApplyNow";
import ContactUs from "./components/ContactUs";
import FAQ from "./components/FAQ-PAGE";
import PrivacyPolicy from './components/PrivacyPolicy';
import TOS from './components/TOS';
import Confirmation from './components/Confirmation';
import ScrollToTop from "./ScrollToTop";
import NotFoundPage from './components/404/NotFoundPage';
import ThankYouPage from './components/ThankYouPage/thankYouPage';
import NavBar from './components/Nav/index';
import CloudPage from './components/CompaniesPage/AcademyPages/CloudAcademy/cloud';
import CyberPage from './components/CompaniesPage/AcademyPages/CyberSecurityAcademy/cyber';
import FixedContact from './components/FixedContact/fixedContact';


const MainPages = () => (
  <div>
    <NavBar />
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route exact path="/browse" component={CoursePage} />
      <Route exact path="/companies" component={CompaniesPage} />
      <Route exact path="/digital" component={DigitalPage} />
      <Route exact path="/stay-relevant" component={StayRelevantPage} />
      <Route exact path="/about-us" component={AboutUsPage} />

      <Route exact path="/digital-marketing" component={DigitalMarketingIntensive} />
      <Route exact path="/web-development-immersive" component={WebDevelopmentImmersive} />
      <Route exact path="/web-development-intensive" component={WebDevelopmentIntensive} />
      <Route exact path="/data-science-immersive" component={DataScienceImmersive} />
      <Route exact path="/data-science-intensive" component={DataScienceIntensive} />
      <Route exact path="/experience-design" component={ExperienceDesign} />

      <Route exact path="/cloud-academy" component={CloudPage} />
      <Route exact path="/cybersecurity-academy" component={CyberPage} />

      <Route exact path="/apply-now" component={ApplyNow} />
      <Route exact path="/contact-us" component={ContactUs} />

      <Route exact path="/faqs" component={FAQ} />

      <Route exact path="/privacy-policy" component={PrivacyPolicy} />
      <Route exact path="/terms-of-service" component={TOS} />

      <Route exact path="/confirmation" component={Confirmation} />
      <Route exact path="/thank-you" component={ThankYouPage} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
    <Footer />
  </div>
)

class App extends Component {
  render() {
    return (
      <Router>
        <ScrollToTop>
          <div className="App">
            <FixedContact/>
            <Switch>
              <Route exact path='/learning' component={LandingPage} />
              <Route component={MainPages} />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>






    );
  }
}

export default App;
